module.exports = __webpack_public_path__ + "img/model_v3_bg_2.cc85a8d3.png";